import { fetchMyPlan, planContextKey } from './planClient.js';
const icons = { free: 'rocket_launch', pro: 'workspace_premium', enterprise: 'diamond', grandfathered: 'all_inclusive' };
const fallback = { caption: 'Your plan', icon: 'workspace_premium' };
let state;
export function selfServePlanBadge(onUpdate) {
  const key = planContextKey();
  if (!key) { state = null; return fallback; }
  if (state?.key !== key) state = { key, pending: false, retryAt: 0 };
  if (state.badge) return state.badge;
  if (!state.pending && Date.now() >= state.retryAt) {
    const requestState = state;
    state.pending = true;
    fetchMyPlan().then(data => {
      if (state !== requestState || planContextKey() !== key) return;
      state.pending = false;
      const plan = data?.plan;
      if (!plan?.key || !plan?.label) { state.retryAt = Date.now() + 30000; return; }
      const caption = plan.key === 'grandfathered' ? plan.label : `${plan.label} plan`;
      const shopifyBilled = plan.key === 'pro' && data.billing_route === 'shopify';
      state.badge = { caption, ...(shopifyBilled ? { billingProvider: 'shopify' } : {}), icon: icons[plan.key] || 'workspace_premium' };
      onUpdate();
    });
  }
  return fallback;
}
